interface IFeatureFlag {
  enable: boolean
  routes: string[]
}

export const useFeatureFlags = () => useState<Record<string, IFeatureFlag>>('feature-flags', () => ({
  teams: {
    enable: false,
    routes: [
      '/my-teams',
      '/team/:id',
      '/team/create',
      '/team/:id/edit',
    ],
  },
  apiKeys: {
    enable: true,
    routes: [],
  },
}))
